module.exports = __webpack_public_path__ + "static/media/check-light-icon.60151e47.svg";